module.exports = __webpack_public_path__ + "img/printer1.112f7d55.png";